import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import Immutable from 'immutable';
import { FormattedMessage } from 'react-intl';
import { allowFreeText } from '@bibliocommons/utils-user';
import { Dropdown, DropdownMenuItem } from '@bibliocommons/base-dropdown';
import { userIdentityShape } from '@bibliocommons/bc-prop-types';
import { IconButton } from '@bibliocommons/base-buttons';
import { Ellipsis } from '@bibliocommons/base-icons';
import { Link } from '@bibliocommons/base-links';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';

const OptionsDropdown = forwardRef(({ id, ugcType, author, handleDelete, handleEdit, hidePermalink }, ref) => {
  const dropdownOptions = [];

  if (author.get('loggedIn') && allowFreeText(author) && !!handleEdit) {
    dropdownOptions.push(
      <DropdownMenuItem
        key={`edit-${ugcType}`}
        handleClick={handleEdit}
        item={Immutable.Map({
          label: <FormattedMessage id={`edit_${ugcType}`} />,
          value: `edit-${ugcType}`
        })}
      />
    );
  }
  if (author.get('loggedIn') && !!handleDelete) {
    dropdownOptions.push(
      <DropdownMenuItem
        key={`delete-${ugcType}`}
        handleClick={handleDelete}
        item={Immutable.Map({
          label: <FormattedMessage id={`delete_${ugcType}`} />,
          value: `delete-${ugcType}`
        })}
      />
    );
  }
  if (!hidePermalink) {
    dropdownOptions.push(
      <DropdownMenuItem key="permalink">
        <Link href={`/v2/${ugcType}/${id}`} dataKey="ugc-permalink">
          <FormattedMessage id="permalink" />
        </Link>
      </DropdownMenuItem>
    );
  }

  return dropdownOptions.length ? (
    <Dropdown
      right
      ref={ref}
      className="cp-ugc-options-dropdown"
      dataKey="ugc-options-dropdown"
      renderTrigger={(handleToggle, expanded) => (
        <IconButton
          handleClick={handleToggle}
          dataKey="ugc-display-ellipsis"
          className="ugc-display-options"
          aria-expanded={expanded}
        >
          <ScreenReaderMessage>
            <FormattedMessage id="ugc_action_menu_sr_label" values={{ username: author.get('name'), ugcType }} />
          </ScreenReaderMessage>
          <Ellipsis />
        </IconButton>
      )}
    >
      {dropdownOptions}
    </Dropdown>
  ) : null;
});

OptionsDropdown.propTypes = {
  id: PropTypes.number.isRequired,
  ugcType: PropTypes.string.isRequired,
  author: userIdentityShape.isRequired,
  handleDelete: PropTypes.func,
  handleEdit: PropTypes.func,
  hidePermalink: PropTypes.bool
};

export default OptionsDropdown;
